export default __webpack_public_path__ + "4394516abb411fbb700d139f10d5fbd9.png";